/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskBatchCreateDto } from '../../models/core-project-task-batch-create-dto';
import { CoreProjectTaskWithSubtasksResponseDto } from '../../models/core-project-task-with-subtasks-response-dto';

export interface ProjectTasksControllerBatchCreateWithSubtasks$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: CoreProjectTaskBatchCreateDto
}

export function projectTasksControllerBatchCreateWithSubtasks(http: HttpClient, rootUrl: string, params: ProjectTasksControllerBatchCreateWithSubtasks$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerBatchCreateWithSubtasks.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectTaskWithSubtasksResponseDto>>;
    })
  );
}

projectTasksControllerBatchCreateWithSubtasks.PATH = '/o2-core/project-tasks/{tenant}/batch';
